import * as Select from '@radix-ui/react-select';
import { type VariantProps, cva } from 'class-variance-authority';
import { PropsWithChildren } from 'react';

const dropdownGroup = cva('flex flex-col space-y-xs');

type DropdownGroupProps = PropsWithChildren<
  VariantProps<typeof dropdownGroup> & {
    label: string;
  }
>;

/**
 * Wrangles in DropdownItems 🤠. To be used within a Dropdown.
 */
export const DropdownGroup = ({ label, children }: DropdownGroupProps) => {
  return (
    <Select.Group className={dropdownGroup()}>
      <Select.Label>{label}</Select.Label>
      <div>{children}</div>
    </Select.Group>
  );
};

DropdownGroup.displayName = 'DropdownGroup';
